module.exports = __webpack_public_path__ + "static/media/cd_player.e6b91ae6.svg";